<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li>
                    <router-link to="/layout/index">首页</router-link>
                </li>
                <li>
                    <router-link to=''>会员中心</router-link>
                </li>
                <li class="currentNode"><a>上传会员风采</a></li>
            </ul>
            <div class="page-main">
                <person-center-menu></person-center-menu>
                <div class="page-content">
                    <h3>上传会员风采</h3>
                    <el-form label-width="100px" :model="form" :rules="rules" ref="ruleForm" class="form" size="small">
                        <el-form-item label="标题" prop="title">
                            <el-input v-model="form.title" placeholder="标题"></el-input>
                        </el-form-item>
                        <el-form-item label="副标题" prop="subTitle">
                            <el-input v-model="form.subTitle" placeholder="副标题"></el-input>
                        </el-form-item>
                        <el-row :gutter="50">
                            <el-col :span="12">
                                <el-form-item label="封面图" prop="imageUrl">
                                    <el-upload class="upload-demo" :action="uploadUrl" :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="1" :on-exceed="handleExceed" :on-success="uploadSuccess" :file-list="fileList" list-type="picture">
                                        <el-button size="small" style="width:350px;border-radius:0;"><i class="el-icon-upload"></i>点击上传</el-button>
                                        <div slot="tip" class="el-upload__tip"><i class="el-icon-info"></i>推荐尺寸：289 x 166</div>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="所属分类" prop="type">
                                    <el-select v-model="form.type" placeholder="请选择">
                                        <el-option v-for="item in typeList" :key="item.label" :label="item.label" :value="item.label">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item label="内容" prop="content">
                            <!-- 内容编辑器 -->
                            <div style="border: 1px solid #ccc; margin-top: 10px;">
                                <!-- 工具栏 -->
                                <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" />
                                <!-- 编辑器 -->
                                <Editor style="height: 400px; overflow-y: hidden;" :defaultConfig="editorConfig" v-model="html" @onChange="onChange" @onCreated="onCreated" />
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="onSubmit" class="submitBtn">提交</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
    
        </div>
    </div>
</template>

<script>
import PersonCenterMenu from '@/components/personCenterMenu.vue'
import {
    baseUrl,
    dddFengcai,
    editFengcai
} from '@services/tokenService.js';
import {
    getPlolicyDetail
} from '@services/indexService.js'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
export default {
    name: '',
    components: {
        Editor,
        Toolbar,
        PersonCenterMenu
    },
    data() {
        return {
            editId: '',
            typeList: [{
                    label: '工作动态',
                    value: '4'
                },
                {
                    label: '名特优产品',
                    value: '4'
                },
                {
                    label: '非物质文化遗产',
                    value: '4'
                }
            ],
            fileList: [],
            useList: [{
                    label: '是',
                    value: 1,
                },
                {
                    label: '否',
                    value: 2,
                }
            ],
            form: {
                title: '',
                subTitle: '',
                type: '',
                imageUrl: '',
                content: ''
            },
            rules: {
                title: [
                    { required: true, message: '请输入标题', trigger: 'blur' },
                    // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                subTitle: [
                    { required: true, message: '请输入副标题', trigger: 'blur' },
                    // { pattern: rulesPattern.phone, message: '请输入正确的手机号', trigger: 'blur' }
                ],
                // publishTime: [
                //     { type: 'date', required: true, message: '请选择时间', trigger: 'change' },
                //     { pattern: rulesPattern.email, message: '请输入正确的邮箱', trigger: 'blur' }
                // ],
                imageUrl: [
                    { required: true, message: '请上传附件', trigger: 'blur' },
                ]
            },
            uploadUrl: `${baseUrl}/api/ZhuJingBanXieHui/UploadFile`,
            editor: null,
            html: '<p></p>',
            toolbarConfig: {
                // toolbarKeys: [ /* 显示哪些菜单，如何排序、分组 */ ],
                // excludeKeys: [ /* 隐藏哪些菜单 */ ],
                excludeKeys: [
                    // 'headerSelect',
                    'fullScreen',
                    'group-more-style',
                    'group-video'
                ]
            },
            editorConfig: {
                placeholder: '请输入内容...',
                // autoFocus: false,

                // 所有的菜单配置，都要在 MENU_CONF 属性下
                MENU_CONF: {
                    'uploadImage': {
                        server: '/api/upload', // 图片上传地址
                    }
                }
            }
        }
    },
    computed: {
        accountId() {
            return this.$store.state.permission.accountId;
        },
        companyId() {
            return this.$store.state.permission.companyId;
        },
        companyName() {
            return this.$store.state.permission.companyName;
        },
        loginName() {
            return this.$store.state.permission.loginName;
        },
        accountType() {
            if (this.$store.state.permission.accountType == 2) {
                this.typeList =  [
                    {
                        label: '工作动态',
                        value: '4'
                    }
                ];
                cosnole.log(this.typeList)
            }
            return this.$store.state.permission.accountType;
        }
    },
    created() {
        if (this.accountId === '') {
            this.$router.push({
                path: '/layout/login',
            });
        }
        if (this.accountType == 2) {
            this.typeList =  [
                {
                    label: '工作动态',
                    value: '4'
                }
            ];
            cosnole.log(this.typeList)
        }
        // 初始化富文本编辑器
        this.initUploadImage();
        // 编辑
        if (this.$route.query.id) {
            this.editId = this.$route.query.id;
            this.getPlolicyDetail();
        }
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁 editor ，重要！！！
    },
    methods: {
        initUploadImage() {
            this.editorConfig.MENU_CONF['uploadImage'] = {
                server: baseUrl + '/api/ZhuJingBanXieHui/UploadFile',
                timeout: 5 * 1000, // 5s

                fieldName: 'file',
                // meta: {},
                metaWithUrl: true, // join params to url
                headers: { Accept: 'text/x-json' },

                maxFileSize: 10 * 1024 * 1024, // 10M

                base64LimitSize: 5 * 1024, // insert base64 format, if file's size less than 5kb

                onBeforeUpload(file) {
                    console.log('onBeforeUpload', file)

                    return file // will upload this file
                    // return false // prevent upload
                },
                onProgress(progress) {
                    console.log('onProgress', progress)
                },
                onSuccess(file, res) {
                    console.log('onSuccess', file, res)
                },
                onFailed(file, res) {
                    alert(res.message)
                    console.log('onFailed', file, res)
                },
                onError(file, err, res) {
                    alert(err.message)
                    console.error('onError', file, err, res)
                },
            }
        },
        onSubmit() {
            if (this.form.content == '<p><br></p>') {
                this.$message.warn("内容不可以为空！");
                return false;
            }
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    if (this.editId) {
                        this.editFengcai();
                    } else {
                        this.dddFengcai(); 
                    }  
                } else {
                    return false;
                }
            });
        },
        onCreated(editor) {
            this.editor = Object.seal(editor) // 【注意】一定要用 Object.seal() 否则会报错
        },
        onChange(editor) {
            this.form.content = editor.getHtml();
        },
        insertTextHandler() {
            const editor = this.editor
            if (editor == null) return
            editor.insertText(' hello ')
        },
        insertHtmlHandler(content) {
            const editor = this.editor;
            if (editor == null) return;
            editor.setHtml(content);
        },
        printEditorHtml() {
            const editor = this.editor
            if (editor == null) return
            return editor.getHtml();
        },
        disableHandler() {
            const editor = this.editor
            if (editor == null) return
            editor.disable()
        },
        // 上传图片 
        uploadSuccess(response, file, fileList) {
            let url = response.data.url;
            console.log(file)
            this.fileList.push({
                name: file.name,
                url: url
            })
            this.form.imageUrl = url;
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        handleRemove(file, fileList) {
            // 去删除的文件
            this.fileList = this.fileList.filter(item => item.url !== file.url);
            this.form.imageUrl = '';
        },
        handlePreview(file) {
            console.log(file);
        },
        getPlolicyDetail(id) {
            let params = {
                id: this.editId,
            };
            getPlolicyDetail(params).then(res => {
                console.log(res);
                if (res.Code === 1) {
                    this.form.title = res.Data.Title;
                    this.form.subTitle = res.Data.SubTitle;
                    this.form.type = res.Data.Description;
                    this.form.imageUrl = res.Data.ImageUrl;
                    let fileArr =  res.Data.ImageUrl.split("/");
                    this.fileList = [{
                        name: fileArr[fileArr.length - 1],
                        url:  res.Data.ImageUrl
                    }];
                    this.form.content = res.Data.Content;
                    this.insertHtmlHandler(this.form.content);
                } else {
                    this.$message.error("风采详情请求失败！");
                }
            })

        },
        dddFengcai() {
            let param = {
                Content: this.editor.getHtml(),
                Title: this.form.title,
                SubTitle: this.form.subTitle,
                PolicyType: this.typeList.filter(item => item.label == this.form.type)[0].value,
                CreateUserId: this.accountId,
                ImageUrl: this.form.imageUrl,
                Description: this.form.type,
                CompanyId: this.companyId,
                CompanyName: this.companyName,
                AccountName: this.loginName
            }
            dddFengcai(param).then(res => {
                if (res.Code == 1) {
                    this.$message.success("保存成功！");
                } else {
                    this.$message.error(res.Message);
                }
            })
        },
        editFengcai() {
            let param = {
                Id: this.editId,
                Content: this.editor.getHtml(),
                Title: this.form.title,
                SubTitle: this.form.subTitle,
                PolicyType: this.typeList.filter(item => item.label == this.form.type)[0].value,
                CreateUserId: this.accountId,
                ImageUrl: this.form.imageUrl,
                Description: this.form.type,
                CompanyId: this.companyId,
                CompanyName: this.companyName,
                AccountName: this.loginName
            }
            editFengcai(param).then(res => {
                if (res.Code == 1) {
                    this.$message.success("保存成功！");
                } else {
                    this.$message.error(res.Message);
                }
            })
        }
    },
}
</script>

<style src="@wangeditor/editor/dist/css/style.css">

</style>

<style scoped>
.page-content {
    padding: 30px;
    min-height: 750px;
}

.page-content h3 {
    text-align: center;
    color: #262626;
    font-size: 22px;
    text-align: center;
    margin-bottom: 30px;
}

.form {
    /* width: 450px; */
    margin: 0 auto;
}

.vertical-nav li a.active {
    border-left: none;
}

.el-select {
    width: 350px;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 350px;
}
.el-upload .el-button:focus, 
.el-upload .el-button:hover{
    background-color: #ecf5ff;
    color: #116EBA; 
}
</style>